import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { useGetMessagesQuery } from '../../../redux/messageView';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default function Inbox() {
  const { data, isLoading } = useGetMessagesQuery();
  const messages = data?.data || [];

  return (
    <div className="flex flex-col items-center p-2 bg-white  h-screen overflow-y-auto">
      <div className="w-full flex-1 max-w-sm pb-20">
        {(isLoading || messages.length === 0) && (
          <>
            <h2 className="text-2xl text-center font-bold text-red-500 mb-2">
              Your inbox is empty
            </h2>
            <p className="text-gray-500 mb-6 text-center">
              Share your link to get questions in your inbox!
            </p>
          </>
        )}

        {isLoading ? (
          <ul className="space-y-4">
            {[1, 2, 3].map((i) => (
              <li key={i} className="flex items-center justify-between bg-white p-4 rounded-xl shadow animate-pulse">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-200 rounded-full" />
                  <div className="flex flex-col gap-2">
                    <div className="w-24 h-4 bg-gray-200 rounded" />
                    <div className="w-16 h-3 bg-gray-200 rounded" />
                  </div>
                </div>
                <div className="w-4 h-4 bg-gray-200 rounded" />
              </li>
            ))}
          </ul>
        ) : messages.length > 0 ? (
          <ul className="space-y-1">
            {messages.map((m) => (
              <Link key={m.id} to={`/messageview/${m.id}`} className="block">
                <li
                  className="flex items-center justify-between bg-white p-4 rounded-xl shadow cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-12 h-12 text-3xl rounded-full flex items-center justify-center relative ${
                      m.is_reply === 1 
                        ? 'bg-gray-100' 
                        : 'bg-gradient-to-r from-red-500 to-red-600'
                    }`}>
                      {m.is_reply === 1 ? (
                        <>
                          💌
                          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs">✓</span>
                          </div>
                        </>
                      ) : (
                        '💌'
                      )}
                    </div>
                    <div>
                      <p className={`font-bold ${
                        m.is_reply === 1 ? 'text-black' : 'text-red-500'
                      }`}>
                        {m.content}
                      </p>
                      <p className="font-semibold text-gray-400 text-sm">
                        {dayjs(m.created_at).fromNow()}
                      </p>
                    </div>
                  </div>
                  <FaChevronRight className="text-gray-300 h-10 w-3" />
                </li>
              </Link>
            ))}
          </ul>
        ) : null}
      </div>

      <button
        className={`mt-4 mb-2 w-[85%] max-w-xs py-3 rounded-full font-semibold transition-colors fixed bottom-6 ${isLoading ? 'bg-black text-white text-lg' : 'bg-gradient-to-r from-red-500 to-red-600 text-white text-base'
          }`}
      >
        {isLoading ? 'Get messages!' : 'Who sent these? 👀'}
      </button>
    </div>
  );
}